import React, { useState } from 'react'
import { TextField } from '@material-ui/core'
import { isBrowser } from 'react-device-detect';

export const LocationControl = ( { preg, handleGuardarCoordenada, handleReferencia, classes } ) => {

    const [referencia_mapa, setDireccion] = React.useState('');
    const [referencia_direccion, setReferencia] = React.useState('');
    const [inputReferencias, setInputReferencias] = useState([
        { id: 0, coordenada: { lat: 0, lng: 0 } , latitud: 0, longitud: 0, direccion: '', referencia: '' },
    ]);

    const handleGuardarReferencia = (e) => {
        inputReferencias[0].referencia = e.target.value;
        setReferencia(e.target.value);
        handleReferencia( e, preg.ID, inputReferencias );
    };

    return (
        <div className={ isBrowser ? "ed-grid s-grid-2 m-grid-6 lg-grid-12 rows-gap" : "ed-grid rows-gap s-gap-1 s-grid-2 m-grid-6 lg-grid-12" }>
            <div className="s-y-1 s-x-1 s-cols-2 
                            m-y-1 m-x-1 m-cols-6
                            l-y-1 l-x-1 l-cols-12">
                <div className={ classes.wrapper }>
                    <TextField className={ classes.inputStyle} 
                    fullWidth 
                    size="small"
                    label="Referencia de la ubicación"
                    name={ "referencia_usuario_" + preg.ID }
                    autoComplete="none"
                    variant="outlined"
                    value={ referencia_direccion }
                    inputProps={ { maxLength: 300 } }
                    onChange={ ( e ) => handleGuardarReferencia( e ) }
                    />
                </div>
            </div>
        </div>
    )
}



// import React, { useState } from 'react'
// import { Button, TextField } from '@material-ui/core'
// import { MapControl } from './Map';
// import { isBrowser } from 'react-device-detect';
// import { useSelector } from 'react-redux';

// export const LocationControl = ( { preg, handleGuardarCoordenada, handleReferencia, classes } ) => {

//     const [openMap, setOpenMap] = React.useState(false);
//     const [ubicacion, setUbicacion] = React.useState({ 'lat': 0, 'lng': 0 });
//     const [referencia_mapa, setDireccion] = React.useState('');
//     const [referencia_direccion, setReferencia] = React.useState('');
//     const [inputReferencias, setInputReferencias] = useState([
//         { id: 0, coordenada: { lat: 0, lng: 0 } , latitud: 0, longitud: 0, direccion: '', referencia: '' },
//     ]);
    
//     let { ubicacion_ie, ubicacion_user } = useSelector( state => state.coordenadas )

//     const handleClickOpenMap = () => {
//         setOpenMap(true);
//     };

//     const handleCloseMap = () => {
//         setOpenMap(false);
//     };

//     const handleGuardarPoint = (e, coor, direccion) => {
//         setUbicacion(coor);
//         setDireccion(direccion);
//         setOpenMap(false);
//         setInputReferencias([{ id: preg.ID, coordenada: coor , latitud: coor.lat, longitud: coor.lng, direccion: direccion, referencia: '' }]);
//         handleGuardarCoordenada( e, preg.ID, inputReferencias );
//     };
        
//     const handleGuardarReferencia = (e) => {
//         inputReferencias[0].referencia = e.target.value;
//         setReferencia(e.target.value);
//         handleReferencia( e, preg.ID, inputReferencias );
//     };

//     return (
//         <div className={ isBrowser ? "ed-grid s-grid-2 m-grid-6 lg-grid-12 rows-gap" : "ed-grid rows-gap s-gap-1 s-grid-2 m-grid-6 lg-grid-12" }>
//             <div className="s-y-1 s-x-1 s-cols-2 
//                             m-y-1 m-x-1 m-cols-2
//                             l-y-1 l-x-1 l-cols-3">
//                 <Button variant="outlined" fullWidth 
//                 color={ ubicacion.lat == 0 ? 'secondary' : 'primary' }
//                 onClick={handleClickOpenMap}>
//                     Seleccione ubicación
//                 </Button>
//                 <MapControl open = { openMap }
//                 handleClose = { handleCloseMap }
//                 handleGuardar = { handleGuardarPoint }
//                 latitud_ie = { ubicacion_ie.lat }
//                 longitud_ie = { ubicacion_ie.lng }
//                 latitud_user = { ubicacion_user.lat }
//                 longitud_user = { ubicacion_user.lng }
//                 coordenadas = { ubicacion }/>

//             </div>
//             <div className="s-y-2 s-x-1 s-cols-2
//                             m-y-1 m-x-3 m-cols-4
//                             l-y-1 l-x-4 l-cols-9">
//                 <div className={ classes.wrapper }>
//                     <TextField className={ classes.inputStyle} 
//                     fullWidth 
//                     size="small"
//                     label="Dirección"
//                     disabled
//                     name={ "referencia_mapa_" + preg.ID }
//                     autoComplete="none"
//                     variant="outlined"
//                     value={ referencia_mapa }
//                     inputProps={ { maxLength: 300 } }
//                     />
//                 </div>
//             </div>
//             <div className="s-y-3 s-x-1 s-cols-2
//                             m-y-2 m-x-3 m-cols-4
//                             l-y-2 l-x-4 l-cols-9" style={{ marginTop: '10px' }}>
//                 <div className={ classes.wrapper }>
//                     <TextField className={ classes.inputStyle} 
//                     fullWidth 
//                     size="small"
//                     label="Referencia de la ubicación (Opcional)"
//                     disabled={ referencia_mapa == '' }
//                     name={ "referencia_usuario_" + preg.ID }
//                     autoComplete="none"
//                     variant="outlined"
//                     value={ referencia_direccion }
//                     inputProps={ { maxLength: 300 } }
//                     onChange={ ( e ) => handleGuardarReferencia( e ) }
//                     />
//                 </div>
//             </div>
//         </div>
//     )
// }
